const appConfig = {
	appScopes: process.env.REACT_APP_AZURE_SCOPES ? process.env.REACT_APP_AZURE_SCOPES.split(',') : [],
	profilePicAppScopes: ['api://5e9c68e3-f31b-4eda-b8b7-79eb3d9ab53b/Read.All'],
	authority: process.env.REACT_APP_AUTHORITY ? process.env.REACT_APP_AUTHORITY : 'https://login.microsoftonline.com/EMCloudAD.onmicrosoft.com',
	clientId: process.env.REACT_APP_CLIENT_ID ? process.env.REACT_APP_CLIENT_ID : '',
	redirectUri: process.env.REACT_APP_CALLBACK_URI ? process.env.REACT_APP_CALLBACK_URI : 'http://localhost:3000/callback',
	logoutUri: process.env.REACT_APP_LOGOUT_URI ? process.env.REACT_APP_LOGOUT_URI : 'http://localhost:3000/callback',
	apiBaseUri: process.env.REACT_APP_API_BASE_URL ? process.env.REACT_APP_API_BASE_URL : 'http://localhost:7071/api/',
	profileImageApi: process.env.ON_PREM_PROFILE_IMAGE_API
		? process.env.ON_PREM_PROFILE_IMAGE_API
		: 'https://svc.apiproxy.exxonmobil.com/mobility-avatar/v1/api/picture/',
};

export default appConfig;
